module.exports = __webpack_public_path__ + "static/sec3-320a290b3385edb531d49d1e9d9b549d.png";